var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register_main_wrap"},[_c('div',{staticClass:"reg_top"},[_vm._v(" "+_vm._s(_vm.$t('loginText1'))+" "),_c('br'),_vm._v(_vm._s(_vm.$t('loginText2'))+" "),_vm._m(0)]),_c('register-component')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/image/main/logo2.png"),"alt":""}})])
}]

export { render, staticRenderFns }